import React from 'react';
import PostList from "./PostList/index";
import { postList, user} from "./data";
import { isUndefined } from 'lodash';
import { useSelector } from "react-redux";
function FlodeWedgit(props) {
    console.log(props,"Editing1")
    const authUser = useSelector(state => state.auth.authUser)
    return (
        <div className='h-100'>
             <div className="d-flex justify-content-center row h-100" 
          >
          <div 
          className="col-sm-12 col-lg-12"
          >
              <div
							className='h-100 d-flex flex-column'
              style={{
                //height:"calc(100vh - 208px)",
                height:isUndefined(props.maxH)?200:props.maxH
              }}
               >
                <PostList postList={postList} user={authUser} 
                height={isUndefined(props.h)?0:props.h}/>
              </div>
          </div>
        </div>
      </div>
    );
}

export default FlodeWedgit;
